import React, { Component } from 'react';
import { connect } from 'react-redux';
import get from 'lodash/get';
import routes from '../../routes';

import { getOriginalLinkAction, endAjaxCallAction } from '../../actions/app.action';

class CustomLinkRedirect extends Component {
  componentWillMount() {
    const { host, protocol } = window.location;
    // Find original link from custom key
    const { match, history, getOriginalLinkAction, endAjaxCallAction } = this.props;

    const customLinkKey = get(match, 'params.customLinkKey', '');
    if (customLinkKey && customLinkKey.length > 0) {
      getOriginalLinkAction({ customLinkKey })
        .then((response) => {
          const originalLinkPathName = get(response, 'data.path', '');
          window.location.href = `${protocol}//${host}${originalLinkPathName}`;
        })
        .catch((error) => history.push(`/${routes.containers.scan}`))
        .finally(() => endAjaxCallAction());
    }
  }

  render() {
    return <>Redirecting...</>;
  }
}

export default connect(null, {
  getOriginalLinkAction,
  endAjaxCallAction,
})(CustomLinkRedirect);
